

export enum API_ERRORS {
  // Módulo carga de CFDIs
  CFDI_UPLOAD_0001 = "CFDI_UPLOAD_0001",
  CFDI_UPLOAD_0002 = "CFDI_UPLOAD_0002",
  CFDI_UPLOAD_0003 = "CFDI_UPLOAD_0003",
  CFDI_UPLOAD_0004 = "CFDI_UPLOAD_0004",
  CFDI_UPLOAD_0005 = "CFDI_UPLOAD_0005",
  CFDI_UPLOAD_0006 = "CFDI_UPLOAD_0006",
  CFDI_UPLOAD_0007 = "CFDI_UPLOAD_0007",
  CFDI_UPLOAD_0008 = "CFDI_UPLOAD_0008",
  CFDI_UPLOAD_0009 = "CFDI_UPLOAD_0009",
}

export const API_ERRORS_DESCRIPTION = {
  [API_ERRORS.CFDI_UPLOAD_0001]: "El nombre del archivo es requerido",
  [API_ERRORS.CFDI_UPLOAD_0002]: "Solo es permitido cargar archivos con extension xml o zip",
  [API_ERRORS.CFDI_UPLOAD_0003]: "El archivo es requerido",
  [API_ERRORS.CFDI_UPLOAD_0004]: "El workspace es invalido o no fue encontrado en el sistema",
  [API_ERRORS.CFDI_UPLOAD_0005]: "Algo salio mal y no fue posible cargar el archivo",
  [API_ERRORS.CFDI_UPLOAD_0006]: "Archivo importado correctamente",
  [API_ERRORS.CFDI_UPLOAD_0007]: "Algo salio mal y no fue posible procesar el archivo",
  [API_ERRORS.CFDI_UPLOAD_0008]: "El archivo ya ha sido cargado previamente",
  [API_ERRORS.CFDI_UPLOAD_0009]: "El archivo XML no pude ser procesable",
}